document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.colfilter-title-wrapper').forEach(function(titleWrapper) {
    titleWrapper.addEventListener('click', function() {
      const container = titleWrapper.nextElementSibling;
      container.classList.toggle('active');

      const chevron = titleWrapper.querySelector('i');
      if (chevron.classList.contains('bi-dash-lg')) {
        chevron.classList.remove('bi-dash-lg');
        chevron.classList.add('bi-plus-lg');
      } else {
        chevron.classList.remove('bi-plus-lg');
        chevron.classList.add('bi-dash-lg');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const openFilterBtn = document.querySelector('.colfilter-btn-wrapper');
  openFilterBtn.addEventListener('click', function() {
    document.querySelector('.collection-filters').classList.add('active');
    document.querySelector('.collection-filter-bck').classList.add('active');
  });

  const closeFilterBtn = document.querySelector('.colfil-close-wrapper');
  closeFilterBtn.addEventListener('click', function() {
    document.querySelector('.collection-filters').classList.remove('active');
    document.querySelector('.collection-filter-bck').classList.remove('active');
  });
});

document.querySelector('.newfil-button-wrapper').addEventListener('click', function() {
  const showTitle = document.querySelector('.newfil-btn-title.show');
  const hideTitle = document.querySelector('.newfil-btn-title.hide');

  if (showTitle.style.display === 'none') {
    showTitle.style.display = 'inline';
    hideTitle.style.display = 'none';
  } else {
    showTitle.style.display = 'none';
    hideTitle.style.display = 'inline';
  }

  const filterContainer = document.querySelector('.collection-filter-container');
  if (filterContainer.classList.contains('hide')) {
    filterContainer.classList.remove('hide');
    filterContainer.classList.add('show');
  } else {
    filterContainer.classList.remove('show');
    filterContainer.classList.add('hide');
  }

  const productGrid = document.getElementById('product-grid');
  if (productGrid.classList.contains('grid--4-col-desktop')) {
    productGrid.classList.remove('grid--4-col-desktop');
    productGrid.classList.add('grid--3-col-desktop');
  } else {
    productGrid.classList.remove('grid--3-col-desktop');
    productGrid.classList.add('grid--4-col-desktop');
  }

  if (productGrid.classList.contains('filter-hide')) {
    productGrid.classList.remove('filter-hide');
    productGrid.classList.add('filter-show');
  } else if (productGrid.classList.contains('filter-show')) {
    productGrid.classList.remove('filter-show');
    productGrid.classList.add('filter-hide');
  }

  const icon = document.querySelector('.newfil-btn-icon');
  if (icon.classList.contains('active')) {
    icon.classList.remove('active');
  } else {
    icon.classList.add('active');
  }
});

document.querySelectorAll('.mob-filter-value').forEach(function(filterValue) {
  filterValue.addEventListener('click', function(event) {
    event.stopPropagation();
    filterValue.classList.toggle('checked');

    var checkbox = filterValue.querySelector('.filter-checkbox');
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
    }
  });
});

document.querySelector('.mob-filter-btn').addEventListener('click', function() {
  var selectedTags = [];
  
  document.querySelectorAll('.mob-filter-value.checked').forEach(function(filterValue) {
    var label = filterValue.querySelector('label');
    if (label) {
      var tag = label.textContent.trim();
      selectedTags.push(encodeURIComponent(tag));
    }
  });

  var currentUrl = window.location.href;
  var urlParts = currentUrl.split('/');
  var collectionsIndex = urlParts.indexOf('collections');

  if (collectionsIndex !== -1 && urlParts.length > collectionsIndex + 1) {
    var collectionHandle = urlParts[collectionsIndex + 1];
    var baseUrl = window.location.origin + '/collections/' + collectionHandle;
    var newUrl = selectedTags.length > 0
      ? baseUrl + '/' + selectedTags.join('+')
      : baseUrl;

    window.location.href = newUrl;
  } else {
    console.error('컬렉션 URL을 확인할 수 없습니다.');
  }
});